import AssessmentsLoader from "pages/PanelPage/AssessmentsLoader/AssessmentsLoader";

export default AssessmentsLoader;
